import React from 'react';
import columns from './columns';
import ProductFilters from './filters-section';
import messages from './messages';
import Breadcrumbs from 'components/Common/Breadcrumb';
import Table from 'features/table';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import {Container} from 'reactstrap';

const ProductsPage = () => {
  const {t} = useTranslation();
  return (
    <div className="page-content pb-0">
      <Helmet>
        <title> {t(...messages.pageTitle())}</title>
      </Helmet>
      <Container fluid>
        <Breadcrumbs
          breadcrumbItems={[
            {title: t('common.dashboard'), path: '/dashboard'},

            {title: t(...messages.products()), path: '#'},
          ]}
        />
        <Table
          columns={columns}
          hideSearch
          url="product-variants"
          name="variants"
          otherParams={{
            delimiter: '|',
          }}
          filtersComponent={ProductFilters}
        ></Table>
      </Container>
    </div>
  );
};

export default ProductsPage;
